import { getEventDesktop } from "app/api/eventsApi";
import { PromoType } from "app/types/promoType";
import { PromoCategories, TabTypes } from "app/utils/const";
import ENV from "config";
import { matchPath } from "react-router-dom";
import store from "../store/store";
import { SessionHelper } from "./sessionHelper";
//
export class PromoCategoryHelper {
  static loadPromotedEvent = (
    props: {
      promoCategory: PromoType;
      history: any;
    },
    mobile: boolean
  ) => {
    const promoCategory = store.getState().promoCategoryModel;
    getEventDesktop(promoCategory.id, false, false)
      .then(resp => {
        const event = resp;
        event.competition.sportType = event.sportType;
        store.dispatch.competitionListModel.updateUnsummarizedMarketsModalEvent(
          event
        );
        // reset the promo category model in store
        store.dispatch.promoCategoryModel.resetPromotedCategory();
        // update path to single event if mobile view and to events if desktop view
        mobile
          ? props.history.replace("/singleevent/" + promoCategory.id + "")
          : props.history.replace("/events/");
      })
      .catch(error => {
        console.error("Failed to load promoted event:", error);
        // Handle the error appropriately here
        return false;
      });
  };

  static loadPromotedCompetition = (props: {
    promoCategory: PromoType;
    history: any;
  }) => {
    const { promoCategory } = props;
    // load single competition fromAPI
    SessionHelper.setSingleCompetitionOnly(true);
    SessionHelper.storeSingleCompetitionOnlyId(promoCategory.id);
    //  use single competition data to update navigation model and reset competition list
    store.dispatch.competitionListModel.setSingleCompetitionList();
    // reset the promo category model in store
    store.dispatch.promoCategoryModel.resetPromotedCategory();
    // update path to events
    props.history.replace("/events/");
  };

  static loadPromotedSport = (props: {
    promoCategory: PromoType;
    history: any;
    selectedCompetitionType: typeof TabTypes;
    time: string;
  }) => {
    const { promoCategory, selectedCompetitionType, time } = props;
    // remove single competition only data just in case
    SessionHelper.setSingleCompetitionOnly(false);
    SessionHelper.removeSingleCompetitionOnlyId();
    SessionHelper.saveNavigationNodeIds(promoCategory.id);

    store.dispatch.competitionListModel.setEuroCompetitionList();

    // reset the promo category model in store
    store.dispatch.promoCategoryModel.resetPromotedCategory();
    // update path to events
    props.history.replace("/events/");
  };

  // if user not authenticated redirect to selected category in public domain
  static redirectToPublicDomain = () => {
    const currentUrl = window.location.href;
    if (!currentUrl.includes("public")) {
      const newUrl = currentUrl.replace(ENV.DOMAIN, ENV.PUBLIC_DOMAIN);
      window.location.href = newUrl;
    }
  };

  // check if route is a promoted route
  // if so update the store with the promoted category data
  static checkIfPromotedRoute = location => {
    const pathname = location.pathname;
    const match = matchPath<{ category: string; id: string }>(pathname, {
      path: "/link/:category/:id",
      exact: true,
      strict: false,
    });
    if (SessionHelper.isAuthenticated()) {
      if (match !== null) {
        const { category, id } = match.params;
        if (
          (category === PromoCategories.Event ||
            category === PromoCategories.Competition ||
            category === PromoCategories.Sport) &&
          !isNaN(Number(id))
        ) {
          store.dispatch.promoCategoryModel.updatePromotedCategory({
            isPromoted: true,
            category: category,
            id: Number(id),
          });
        }
      }
    } else {
      if (match !== null) {
        const { category, id } = match.params;
        if (
          (category === PromoCategories.Event ||
            category === PromoCategories.Competition ||
            category === PromoCategories.Sport) &&
          !isNaN(Number(id))
        ) {
          // if user not authenticated redirect to selected category in public domain
          PromoCategoryHelper.redirectToPublicDomain();
        }
      }
    }
  };
  // moving checks for promoted category updates out of the component
  // in to helper to try and reduce size of componentDidUpdate in components
  static updatePromotedCategories = (
    promoCategory,
    props,
    prevProps,
    mobile
  ) => {
    // check if the promoted event category has changed
    if (
      !promoCategory.promoEventLoading &&
      promoCategory.category === PromoCategories.Event &&
      !prevProps.promoCategory.promoEventLoading
    ) {
      if (!promoCategory.promoEventLoading) {
        mobile && store.dispatch.competitionListModel.setFullListLoaded(true);
        store.dispatch.promoCategoryModel.updatePromoEventLoading(true);
        PromoCategoryHelper.loadPromotedEvent(props, mobile);
      }
    }

    // if promoted competition load selected competition and competition events
    if (
      !promoCategory.promoCompetitionLoading &&
      promoCategory.category === PromoCategories.Competition &&
      !prevProps.promoCategory.promoCompetitionLoading
    ) {
      if (!promoCategory.promoCompetitionLoading) {
        mobile && store.dispatch.competitionListModel.setFullListLoaded(true);
        store.dispatch.promoCategoryModel.updatePromoEventLoading(true);
        PromoCategoryHelper.loadPromotedCompetition(props);
      }
    }
    // if promoted sport load selected sport, competitions and events
    if (
      !promoCategory.promoSportLoading &&
      promoCategory.category === PromoCategories.Sport &&
      !prevProps.promoCategory.promoSportLoading
    ) {
      if (!promoCategory.promoCompetitionLoading) {
        store.dispatch.promoCategoryModel.updatePromoEventLoading(true);
        PromoCategoryHelper.loadPromotedSport(props);
      }
    }
  };
}
